import { Navigate, RouteObject } from "react-router-dom";
import MainLayout from "./components/layouts/MainLayout";
import SamplePage from "./components/pages/SamplePage";
import DashboardPage from "./components/pages/DashboardPage";
import ConnectionsPage from "./components/pages/ConnectionsPage";
import NotificationsPage from "./components/pages/NotificationsPage";
import AlertsPage from "./components/pages/AlertsPage";
import ReportsPage from "./components/pages/ReportsPage";
import UsersPage from "./components/pages/UsersPage";
import AccountPage from "./components/pages/AccountPage";
import TileFormPage from "./components/pages/TileFormPage";
import TileDetailPage from "./components/pages/TileDetailPage";
import DashboardFormPage from "./components/pages/DashboardFormPage";
import DemoPage from "./components/pages/DemoPage";
import AuthLicenseGate from "./components/layouts/AuthLicenseGate";

const routes = (productLicensed?: boolean): RouteObject[] => [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { path: "error", element: <></>, index: true },
      {
        element: <AuthLicenseGate productLicensed={productLicensed} />,
        children: [
          { path: "add-tile", element: <TileFormPage />, index: true },
          { path: "edit-tile/:id", element: <TileFormPage />, index: true },
          {
            path: "add-dashboard",
            element: <DashboardFormPage />,
            index: true,
          },
          {
            path: "edit-dashboard/:id",
            element: <DashboardFormPage />,
            index: true,
          },
          { path: "dashboard", element: <DashboardPage />, index: true },
          { path: "dashboard/:id", element: <DashboardPage />, index: true },
          { path: "tile/:id", element: <TileDetailPage />, index: true },
          { path: "connections", element: <ConnectionsPage />, index: true },
          {
            path: "notifications",
            element: <NotificationsPage />,
            index: true,
          },
          { path: "alerts", element: <AlertsPage />, index: true },
          { path: "reports", element: <ReportsPage />, index: true },
          { path: "users", element: <UsersPage />, index: true },
          { path: "users/:id", element: <UsersPage />, index: true },
          { path: "account", element: <AccountPage />, index: true },
          {
            path: "demo",
            element:
              process.env.REACT_APP_ENV === "Development" ||
              process.env.REACT_APP_ENV === "Staging" ? (
                <DemoPage />
              ) : (
                <Navigate to="/dashboard" />
              ),
            index: true,
          },
          { path: "sample", element: <SamplePage />, index: true },
          { path: "", element: <Navigate to="/dashboard" />, index: true },
          { path: "*", element: <Navigate to="/dashboard" />, index: true },
        ],
      },
    ],
  },
];

export default routes;
